import { Injectable } from '@angular/core';
import { ApiInterfaceService } from './api-interface.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from '../base.service';
import { environment } from 'src/environments/environment';
import { SharedMemoryService } from '../shared-memory.service';
import { Subscription } from 'rxjs';
import { ApiUsuarioService } from '../api-usuario.service';
import { ApiClienteService } from '../api-cliente.service';
import { ApiCorretoraService } from 'src/app/services/api-corretora.service';
import { SeguradoraWakandaAtiva } from '../../models/seguradora/entities/wakanda-ativa.model';
import { SeguradoraCalcular } from '../../models/seguradora/entities/calcular.model';
import { SeguradorasStatus } from '../../models/seguradoras/entities/status.model';
import { ServicesInfosBase } from '../../models/services-infos.model';
import { UtilsService } from '../utils.service';
import { CotacaoService } from '../cotacao/cotacao.service';
import { ClienteModelForm, ClienteModel } from 'src/app/models/cliente.model';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { SeguradorasBase } from 'src/app/models/seguradoras/factory/base.model';

//recalculo
import { ApiSeguradoraService } from '../api-seguradora.service';
@Injectable({
  providedIn: 'root'
})

export class ApiApiceService implements ApiInterfaceService {
  private subscriptions: any = new Subscription();
  private ENV: any = environment;
  private URL;
  public optionsViagem;
  public optionsBike;
  public optionsAlguel;
  public coberturas;
  public servicesInfos;
  public wakUser = {
    confsSeguradora: []
  }
  private _seguradorasBase: SeguradorasBase = IntegracaoConstants.seguradoras;

  /** CONTROLLER PARA ATUALIZAR O CLIENTE NA LISTA DE CLIENTES CASO SEJA EDITADO */
  updateClienteModal: boolean = false;

  constructor(
    private http: HttpClient,
    private BS: BaseService,
    private utilsService: UtilsService,
    private sharedMemoryService: SharedMemoryService,
    private cotacaoService: CotacaoService,
    private apiUsuario: ApiUsuarioService,
    private apiCliente: ApiClienteService,
    private apiSeguradora: ApiSeguradoraService,
    private apiCorretora: ApiCorretoraService) {
    this.URL = this.ENV.apice.url;
    this.sharedMemoryService.addSubscription(this, 'servicesInfos', (data) => { this.servicesInfos = data; });
  }

  //recalculo e seguradoras inicio
  async getListCfgsSegs() {

    let result: any = await this.http.get(this.URL + 'cfg/seguradora/config', this.BS.getHeaders(true)).toPromise();

    return result

  }
  // para o recalculo
  async getToken(){
    const tokenPdocs = await this.apiUsuario.autenticaNoPDocs();

    return tokenPdocs.token
  }

  async reenviar(id){
    try{
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/reenviar/${id}`

      let ret:any = await this.http.post(url,{},{headers}).toPromise()
      return ret
    }catch(err){
      if (err?.error?.message === "Cannot read properties of null (reading 'configsSeg')")
         await this.utilsService.createAlert("Atenção", "Não é possível recalcular.");
      return false
    }
  }

  // fim
  preparaConfig(dados){
    debugger
      var obj = {
        configId: dados?.config?.seguradora ? dados?.config?.seguradora : dados?.seguradora?.id,
        seguradoraId: dados?.seguradora?.id,
        aplicacaoId: 3,
        nomeSeguradora: dados?.seguradora?.nome
      }

      if (dados?.recalculo){
        obj.configId = dados.seguradora
        obj.seguradoraId = dados.seguradora
        obj.nomeSeguradora = ''
      }

      return obj

  }

  preparaJSON(json) {
    let list = json ?? json

    debugger
    if (typeof list === 'string')
        list = JSON.parse(list)
    if (!list)
        list = []

    return list
  }

  preparaObjetoValidaLogin(objLogin, config){
    return objLogin
  }

  async validaCredenciaisSeguradora(body) {
    try {
        let result:any = null
        let headers = await this.autenticaPdcos();

        result = await this.http.post(this.ENV.multi.url + 'calculo/validarLogin', body,  { headers: headers }).toPromise();
        return result.data
    } catch (error) {
        return false
    }
  }

  async cargaInicialDocumentos(idIntegracaoCfg){
    return this.apiSeguradora.cargaInicialDocumentos(idIntegracaoCfg)
  }

  async salvarCredenciaisSeg(body) {

    let objSalvarConfig: any = {}
    objSalvarConfig.configsSeg = {}
    let configsSeg: any = {}

    let credenciais: any = body.objCredenciais
    let objcomissaoDesconto = body.objcomissaoDesconto
    let objDadosComplementares = body.objdadosComplementares
    let objIntegracoes = body.objIntegracoes

    configsSeg.configsGlobais = body.objCredenciais.configsGlobais
    configsSeg.permiteAcessoDemais = body.objConfigSeg.permiteAcessoDemais
    configsSeg.ativo = body.objConfigSeg.ativo

    objSalvarConfig.seguradora = body.objConfigSeg.seguradora
    objSalvarConfig.ativo = body.objConfigSeg.ativo
    objSalvarConfig.login = body.objCredenciais.usuario
    objSalvarConfig.senha = body.objCredenciais.senha

    objSalvarConfig = { ...objSalvarConfig, ...objIntegracoes }
    objSalvarConfig.configsSeg = { ...credenciais, ...configsSeg, ...objcomissaoDesconto, ...objDadosComplementares, ...objIntegracoes }


    // let result: any = await this.http.post(this.URL + 'cfg/seguradora/objSalvarConfig', objSalvarConfig, this.getHeaders(true)).toPromise();
    let result: any = await this.http.post(this.URL + 'cfg/seguradora/config', objSalvarConfig, this.BS.getHeaders(true)).toPromise();

    if (result.msg)
        result.message = result.msg
    return result

  }

  async getCfgsSeg(id) {
    let result: any = await this.http.get(this.URL + 'cfg/seguradora/config?seguradoraId=' + id, this.BS.getHeaders(true)).toPromise();
    return result

  }

  //recalculo e seguradoras fim
  async getSeguradoById(id:string) {
    try {
      let ret:any = await this.http.get(this.URL + 'cadastros/cliente/' + id, this.BS.getHeaders(true)).toPromise();
      if (ret) {
        ret.estadoCivil = parseInt(ret.estadoCivil);
        ret.dataNasc = ret.dataNas;
        if (ret?.enderecos?.length) {
          ret.cep = ret?.cep ? ret?.cep : ret?.enderecos[0]?.cep;
          ret.logradouro = ret?.logradouro ? ret?.logradouro : ret?.enderecos[0]?.logradouro;
          ret.numero = ret?.numero ? ret?.numero : ret?.enderecos[0]?.numero;
          ret.uf = ret?.uf ? ret?.uf : ret?.enderecos[0]?.uf;
          ret.cidade = ret?.cidade ? ret?.cidade : ret?.enderecos[0]?.cidade;
          ret.complemento = ret?.complemento ? ret?.complemento : ret?.enderecos[0]?.complemento;
          ret.bairro = ret?.bairro ? ret?.bairro : ret?.enderecos[0]?.bairro;
          ret.residLogradouro = ret?.logradouro ? ret?.logradouro : ret?.enderecos[0]?.logradouro;
          ret.residNumero = ret?.numero ? ret?.numero : ret?.enderecos[0]?.numero;
          ret.residUF = ret?.uf ? ret?.uf : ret?.enderecos[0]?.uf;
          ret.residCidade = ret?.cidade ? ret?.cidade : ret?.enderecos[0]?.cidade;
          ret.residBairro = ret?.bairro ? ret?.bairro : ret?.enderecos[0]?.bairro;
        }
      }
      return new ClienteModel().deserialize(ret);
    } catch (error) {
      throw error;
    }

  }

  async delay(ms) {
    return await new Promise(resolve => setTimeout(resolve, ms));
  }

  async testVar(varToTest, tentativas, timeout){
    for(let i=0;i<tentativas;i++){
        if(this[varToTest])
            break;
        else
            await this.delay(timeout);
    }
    return this[varToTest];
  }

  async sendEmail() {
    //TODO: Implementar conforme interface
    console.log("Função não implementada!");
    return false;
  }

  async getServicesInfos() {
    //TODO: Implementar conforme interface
    await this.updateServicesInfos();
    return await this.testVar("servicesInfos", 20, 250);
  }

  async getSeguradoraStatus() {
    let headers = await this.autenticaPdcos();
    const url = this.ENV.multi.url + 'app/seguradoraStatus/';
    return this.http.get(url, { headers: headers }).toPromise();
  }

  async getCfgSeg(idIntegracao) {
    return this.http.get(this.URL + `cfg/seguradora/credencial/${idIntegracao}`, this.BS.getHeaders(true)).toPromise();
  }

  calcular(cotacao, negocio?) {
    if (cotacao.negocioId) {
      negocio = { id: cotacao.negocioId }
    }else if(cotacao.negocioUrl){
      negocio = { id: cotacao.negocioUrl }
    }

    let body = {
      apiV2: true,
      cotacao: cotacao,
      negocio: negocio || null
    }

    return this.http.post(this.URL + 'calculo/calcularV2', body, this.BS.getHeaders(true)).toPromise();
  }

  async getUserInfos() {
    let corretora:any = await this.apiCorretora.buscaCorretora();
    let conf:any = await this.getSeguradorasUser()
    let userInfos = await this.apiUsuario.getCredenciais();

    userInfos.confsSeguradora = conf
    userInfos.resultadoParcOpc1 = corretora?.configsCorretora?.resultadoParcOpc1 ? corretora?.configsCorretora?.resultadoParcOpc1 : 1;
    userInfos.resultadoParcOpc2 = corretora?.configsCorretora?.resultadoParcOpc2 ? corretora?.configsCorretora?.resultadoParcOpc2 : 1;
    userInfos.fone = corretora.fone;
    userInfos.foneCorretoraPadrao = userInfos.foneCorretora;
    userInfos.emailCorretoraPadrao = userInfos.emailCorretora;
    userInfos.propostaObsPadrao = corretora?.configsCorretora?.mensagemOrcamento || '';
    if (corretora?.configsCorretora?.formaPagPadrao) {
      if (corretora.configsCorretora.formaPagPadrao == "Boleto") {
        userInfos.propostaTipoPagtoPadrao = 3;
      } else if (corretora.configsCorretora.formaPagPadrao == "Débito em conta") {
        userInfos.propostaTipoPagtoPadrao = 2;
      } else if (corretora.configsCorretora.formaPagPadrao == "Cartão de crédito") {
        userInfos.propostaTipoPagtoPadrao = 1;
      }
    }
    return userInfos;
  }

  async copiarNegocio(cotacao) {
    let negocio = await this.getNegocio(cotacao);
    let draftCopia = await this.cotacaoService.geraJsonCopia(negocio);
    let ret = await this.saveNegocio(draftCopia).then((ret: any) => {
      return ret;
    });
    return ret;
  }

  async getCoberturasAutoUser() {
    if (!this.coberturas) {
      let coberturas = await this.http.get(this.URL + 'cfg/cobertura', this.BS.getHeaders(true)).toPromise();
      let corretora: any = await this.http.get(this.URL + 'cfg/corretora', this.BS.getHeaders(true)).toPromise();
      let pacotePadrao = corretora.configsCorretora?.pacoteCobertPadrao.toLowerCase();
      coberturas[pacotePadrao].default = true;
      this.coberturas = coberturas;
    }
    return this.coberturas;
  }

  async autenticaPdcos(){
    try {
      let tokenPdocs = await this.apiUsuario.autenticaNoPDocs();
      if(tokenPdocs?.token){
        let headers = new HttpHeaders();
        headers = headers.set('authorization', tokenPdocs.token);
        this.apiUsuario.setCredenciaisPDocs(tokenPdocs)
        return headers
      }else{
        throw new Error('Não autenticado');
      }
    } catch (error) {
      throw error;
    }
  }

  async getCalculos(idIntegracao, version) {
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + 'calculo/cotacao/calculos/' + idIntegracao + '/' + version;
      return this.http.get(url, { headers: headers }).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async getSeguradorasUser() {
    //TODO: Implementar conforme interface
    // console.log('getSeguradorasUser');
    let result: any = await this.http.get(this.URL + 'calculo/seguradorasMulti', this.BS.getHeaders(true)).toPromise();
    result.forEach(seguradora => {
      let id = seguradora.id
      delete seguradora.id
      seguradora.ID = id;
    });
    return result;
  }

  async getVersoes(idIntegracao) {
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + 'calculo/cotacao/versoes/' + idIntegracao;
      return this.http.get(url, { headers: headers }).toPromise();

    } catch (error) {
      throw error;
    }
  }

  async getNegocio(idIntegracao) {
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + 'calculo/negocio/' + idIntegracao;
      return this.http.get(url, { headers: headers }).toPromise();

    } catch (error) {
      throw error;
    }
  }

  async saveNegocio(cotacao, negocio?) {
    if (cotacao && !cotacao.hasOwnProperty('ramo')) {
      // debugger
      cotacao.ramo = 31;
    }

    // debugger
    if (cotacao.negocioId) {
      negocio = { id: cotacao.negocioId }
    }else if(cotacao.negocioUrl){
      negocio = { id: cotacao.negocioUrl }
    }

    let body = {
      apiV2: true,
      cotacao: cotacao,
      negocio: negocio || null
    }
    // debugger
    return this.http.post(this.URL + 'calculo/calcularV2?salvar=true', body, this.BS.getHeaders(true)).toPromise();
  }

  //implementar função
  async updateSegurado(cpf) {
    let result = await this.apiCliente.buscaClientePorCpfCnpj(cpf, undefined, true);
    if (result?.length) {
      result[0].estadoCivil = parseInt(result[0].estadoCivil);
      result[0].dataNasc = result[0].dataNas;
      if (result[0]?.enderecos?.length) {
        result[0].cep = result[0]?.cep ? result[0]?.cep : result[0]?.enderecos[0]?.cep;
        result[0].logradouro = result[0]?.logradouro ? result[0]?.logradouro : result[0]?.enderecos[0]?.logradouro;
        result[0].numero = result[0]?.numero ? result[0]?.numero : result[0]?.enderecos[0]?.numero;
        result[0].uf = result[0]?.uf ? result[0]?.uf : result[0]?.enderecos[0]?.uf;
        result[0].cidade = result[0]?.cidade ? result[0]?.cidade : result[0]?.enderecos[0]?.cidade;
        result[0].complemento = result[0]?.complemento ? result[0]?.complemento : result[0]?.enderecos[0]?.complemento;
        result[0].bairro = result[0]?.bairro ? result[0]?.bairro : result[0]?.enderecos[0]?.bairro;
      }
    }
    return result
  }

  //implementar função
  async updateEndereco(cep) {
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/cep?cep=${cep}`;

      let result = await this.http.get(url, { headers: headers }).toPromise();

      if (result[0] && result[0].uf != null && result[0].cidade != null)
          return result

      return false
    } catch (error) {
      // throw error;
      console.log(error);
      return false
    }
  }

  //implementar função
  async getCalculoFipeModelo(fipe, ano, isZeroKm){
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/fipeModelo?ano=${ano}&fipe=${fipe}&zero=${isZeroKm}`;
      return await this.http.get(url, { headers: headers }).toPromise();
    } catch (error) {
      throw error;
    }
  }

  //implementar função
  async getCalculoValorMedio(fipe, ano, cep, maior25, historico){
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/valorMedio?fipe=${fipe}&ano=${ano}&cep=${cep}&maior25=${maior25}&historico=${historico}`;
      let ret = await this.http.get(url, { headers: headers }).toPromise();
      console.log('BUSCOU CALCULOR VALOR MEDIO', ret);
      return ret
    } catch (error) {
      throw error;
    }

  }

  //implementar função
  async getCalculoDescricaoModelo(tipo, modelo, ano){
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/fipeModelo?tipo=${tipo}&modelo=${modelo}&ano=${ano}`;
      return this.http.get(url, { headers: headers }).toPromise();
    } catch (error) {
      throw error;
    }
  }

   //implementar função
  async getCalculoPlacaModelo(placa){
    try {
      let headers = await this.autenticaPdcos();
      const url = encodeURI(`${environment.multi.url}calculo/buscaPlaca?placa=${placa}`);
      return this.http.get(url, { headers: headers }).toPromise();
    } catch (error) {
      throw error;
    }
  }

   //implementar função
  async getCalculoChassiModelo(chassi){
    try {
      let headers = await this.autenticaPdcos();
      const url = encodeURI(`${environment.multi.url}calculo/chassiDecoder?chassi=${chassi}`);
      return this.http.get(url, { headers: headers }).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async getSeguradoraAnterior(){
    try {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/seguradorasRenovacao`;
      return this.http.get(url, { headers: headers }).toPromise();
    } catch (error) {
      throw error;
    }
  }

  getUrlBase(ramo, full?){
    return "/cotacao/" + ramo + "/";
  }

  getAplicacaoId(){
    return 3;
  }

  public async updateServicesInfos() {
    let headers = new HttpHeaders();
    let tokenPdocs
    try {
      tokenPdocs = await this.apiUsuario.autenticaNoPDocs();
      headers = headers.set('authorization', tokenPdocs?.token);
    } catch (error) {
      throw error
    }

    if(tokenPdocs?.token){
      // const url = this._url + 'app/seguradoraStatus';
      const url = this.ENV.production ? 'https://api.multicalculo.net/' + 'app/seguradoraStatus' : 'https://dev-api.multicalculo.net/' + 'app/seguradoraStatus';
      this.http.get(url, {headers: headers}).toPromise()
      .then((retJsonSeguradorasMulti:any) => {

        if(retJsonSeguradorasMulti.length) {

          let jsonSeguradorasMulti:any = retJsonSeguradorasMulti;

          try {

            let listaSegs : SeguradoraWakandaAtiva[] = jsonSeguradorasMulti;
            let objRet = new ServicesInfosBase();

            listaSegs.forEach(function(s: SeguradoraWakandaAtiva){

              let segCalc = new SeguradoraCalcular(s.id, true, this.utilsService.getSegNameById(s.id), 0, 0, this.utilsService.getPathLogoById(s.id));

              this.addSegService(objRet.calculos.auto.car, s.autoStatus, segCalc);
              this.addSegService(objRet.calculos.auto.moto, s.motoStatus, segCalc);
              this.addSegService(objRet.calculos.auto.truck, s.caminhaoStatus, segCalc);
              this.addSegService(objRet.calculos.pacote.residencial, s.residStatus, segCalc);
              this.addSegService(objRet.calculos.pacote.empresarial, typeof s.empresarialStatus === "number" ? s.empresarialStatus : parseInt(s.empresarialStatus), segCalc);
              this.addSegService(objRet.buscarDocumentos.auto, s.documentosStatus, segCalc);
              this.addSegService(objRet.parcelasPendentes , s.parcelasStatus, segCalc);
              this.addSegService(objRet.acompanhamento, s.acompanhamentoStatus, segCalc);
              this.addSegService(objRet.calculos.vida.individual, s.vidaStatus, segCalc);
              this.addSegService(objRet.calculos.vida.global, s.vidaGlobalStatus, segCalc);
              this.addSegService(objRet.calculos.vida.acidentesPessoais, s.acidentesPessoaisIndividualStatus, segCalc);
              this.addSegService(objRet.calculos.vida.viagem, s.viagemStatus, segCalc);
              this.addSegService(objRet.calculos.condominio, s.condominioStatus, segCalc);
              this.addSegService(objRet.calculos.aluguel, s.aluguelStatus, segCalc);
              this.addSegService(objRet.calculos.bike, s.bikeStatus, segCalc);

            }.bind(this));

            this.servicesInfos = objRet;
            this.sharedMemoryService.set('servicesInfos', objRet);

          } catch(e){
            console.log(e);
            this.servicesInfos = null;
            this.sharedMemoryService.set('servicesInfos', null);
          }

        } else {
          this.servicesInfos = null;
          this.sharedMemoryService.set('servicesInfos', null);
        }

      })
      .catch(e => {
        console.log(e);
        this.servicesInfos = null;
        this.sharedMemoryService.set('servicesInfos', null);
      });

    }

  }

  private getSegStatus(status: number){
    switch (status){
      case 0: return 'desabilitadas';
      case 1: return 'habilitadas';
      default: return false;
    }
  }

  private addSegService(arr: SeguradorasStatus, status: number, obj: SeguradoraCalcular) : void{
    let segStatus = this.getSegStatus(status);
    if(segStatus)
      arr[segStatus].push(obj);
  }

    //implementar função
    async sendMessageByObservable(property, value){
      return false;
    }

    //implementar função
    async forceRefreshHome(){
      return false;
    }

    async getCotacoesCpfCnpj(cpfCnpj: string, ramo: string) {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.multi.url + `calculo/seguradoCotadoRecentemente?cpfCnpj=${cpfCnpj}&ramo=${ramo}`;
      return await this.http.get(url, { headers: headers }).toPromise();
    }

    async getCategoriaTarifariaPorto(fipe, anoModelo, zeroKm, placa, descricao) {
      let headers = await this.autenticaPdcos();
      if(!placa) placa = false;
      let body = {
        filename: "getCategoriaTarifariaPorto.php",
        queryStringParams: {
          fipe: fipe,
          anoModelo: anoModelo,
          zeroKm: zeroKm,
          placa: placa,
          descricao: descricao
        }
      };
      const url = this.ENV.multi.url + 'calculo/execLBMultiBots';
      return await this.http.post(url, body, { headers: headers }).toPromise();
    }

  async getCategoriaTarifariaLiberty(fipe, combustivel, tipo, valReferenciado, pctAjuste, blindagemValor, gasInstalValor, seguradora, idIntegracaoCfgSeg) {
    let headers = await this.autenticaPdcos();
    let body = {
      filename: "getVeiculoSeguradoraLiberty.php",
      queryStringParams: {
        fipe: fipe,
        combustivel: combustivel,
        tipo: tipo,
        valReferenciado: valReferenciado,
        pctAjuste: pctAjuste,
        blindagemValor: blindagemValor,
        gasInstalValor: gasInstalValor,
        seguradora: seguradora,
        idIntegracaoCfgSeg: idIntegracaoCfgSeg
      }
    };
    const url = this.ENV.multi.url + 'calculo/execLBMultiBots';
    return await this.http.post(url, body, { headers: headers }).toPromise();
  }

  async getSegurado(cpf: string, simplificado: boolean = true, apenasBuscaLocal: boolean = false) {
    const maxTentativas = 3;
    let tentativas = 0;
    let refazer = false;
    let erroTimeOut = false;
    do {
      try {
        tentativas++
        const url = this.URL + `cadastros/cliente?cpfCnpj=${cpf}&simplificado=${simplificado}&apenasBuscaLocal=${apenasBuscaLocal}`;
        let result: any = [await this.http.get(url, this.BS.getHeaders(true)).toPromise()];
        if (result?.length > 0 && result[0]) {
          result[0].estadoCivil = parseInt(result[0].estadoCivil);
          result[0].dataNasc = result[0].dataNas;
          const camposEndereco = ['cep', 'logradouro', 'numero', 'uf', 'cidade', 'complemento', 'bairro'];
          if (result[0]?.enderecos?.length) {
            camposEndereco.forEach(campo => { result[0][campo] = result[0][campo] });
            result[0].cep = result[0]?.cep ? result[0]?.cep : result[0]?.enderecos[0]?.cep;
            result[0].logradouro = result[0]?.logradouro ? result[0]?.logradouro : result[0]?.enderecos[0]?.logradouro;
            result[0].numero = result[0]?.numero ? result[0]?.numero : result[0]?.enderecos[0]?.numero;
            result[0].uf = result[0]?.uf ? result[0]?.uf : result[0]?.enderecos[0]?.uf;
            result[0].cidade = result[0]?.cidade ? result[0]?.cidade : result[0]?.enderecos[0]?.cidade;
            result[0].complemento = result[0]?.complemento ? result[0]?.complemento : result[0]?.enderecos[0]?.complemento;
            result[0].bairro = result[0]?.bairro ? result[0]?.bairro : result[0]?.enderecos[0]?.bairro;
          }
          return result;
        } else if (tentativas > maxTentativas)
          return null;
        else
          await this.delay(5000);
      } catch (error) {
        refazer = false;
        erroTimeOut = error.status == 504 || error.status == 0 || false;
        if (tentativas <= maxTentativas && erroTimeOut) {
          refazer = true;
          apenasBuscaLocal = true;
        } else
          return null;
      }
    } while (refazer);
  }

  async getEndereco(cep) {
    return this.updateEndereco(cep);
  }


  getUrlHome() {
    return 'cotacoes';
  }

  async getCorretoraById(id: string) {
    return false;
    // Comentado até backend desenvolver a API: https://github.com/InfocapTI/p-docs/issues/2003
    // let headers = await this.autenticaPdcos();
    // const url = this.ENV.multi.url + `app/rest/corretora/${id}`;
    // return this.http.get(url, { headers: headers }).toPromise();
  }

  // public async getOptionsEmpresarial() {
  //   let headers = await this.autenticaPdcos();
  //   const url = this.ENV.aggilizador.url + 'Business/Data';
  //   return await this.http.get(url, { headers: headers }).toPromise();
  // }

  public async getOptionsVidaGlobal() {
    let headers = await this.autenticaPdcos();
    const url = this.ENV.aggilizador.url + 'LifeGlobal/Data/Full';
    return await this.http.get(url, { headers: headers }).toPromise();
  }

  public async getOptionsEmpresarial() {
    let headers = await this.autenticaPdcos();
    const url = this.ENV.aggilizador.url + 'Business/Data';
    return await this.http.get(url, { headers: headers }).toPromise();
  }

  public async getOptionsViagem() {
    if (!this.optionsViagem) {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.aggilizador.url + 'Travel/Data';
      let ret = await this.http.get(url, { headers: headers }).toPromise();
      this.optionsViagem = ret;
      return ret;
    } else {
      return this.optionsViagem;
    }
  }

  public async getOptionsBike() {
    if (!this.optionsBike) {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.aggilizador.url + 'Bike/Data';
      let ret = await this.http.get(url, { headers: headers }).toPromise();
      this.optionsBike = ret;
      return ret;
    } else {
      return this.optionsBike;
    }
  }

  public async getOptionsAluguel() {
    if (!this.optionsAlguel) {
      let headers = await this.autenticaPdcos();
      const url = this.ENV.aggilizador.url + 'Rent/Data';
      let ret = await this.http.get(url, { headers: headers }).toPromise();
      this.optionsAlguel = ret;
      return ret;
    } else {
      return this.optionsAlguel;
    }
  }

  public async getOptionsBySegFull(executionType, filterText) {
    let headers = await this.autenticaPdcos();
    const url = this.ENV.multi.url + `calculo/getOptionsBySegFull?executionType=${executionType}&filterText=${filterText}`;
    return await this.http.get(url, { headers: headers }).toPromise();
  }

  getNomeLoader() {
    return 'loader-apice';
  }

  async buscarParcelas(tipo, seguradoras, diasParaTras, periodo) {
    let body = {
      tipo: tipo,
      seguradoras: seguradoras,
      diasParaTras: diasParaTras,
      periodo: periodo
    }
    let headers = await this.autenticaPdcos();
    const url = this.ENV.multi.url + 'cor/enviarRequisicao';
    return this.http.post(url, body, { headers: headers }).toPromise();
  }

  public async getParcelasPendentes() {
    let headers = await this.autenticaPdcos();
    let url = this.ENV.multi.url + 'cor/getParcelasPendentes';
    return this.http.get(url, { headers: headers }).toPromise();
  }

  async getTokenJustos(usuario: string) {
    try {
      const { data } =  await this.validaCredenciaisSeguradora({usuario: usuario, seguradora: this._seguradorasBase.JUSTOS.id, validarLogin: 1, acao: 2});
      const body = data?.body ?? [];
      const justosToken = body.length > 0 ? body[0]?.Key : null;
      return justosToken ?? null;
    } catch (error) {
      console.log("Erro ao buscar token Justos" + error);
      return null;
    }
  }

}
